import { useEffect, useRef, useState } from 'react';
import './prize-packs-landing.styles.scss';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import PrizePacksForm from './prize-packs-form.component';
import PrizePacksList from './prize-packs-list.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';

const PrizePacksLanding = ({
  gameData,
  gameStats,
  gameElements,
  playerList,
  role
}) => {

  const membership = useEffectiveMembership();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [prizepacksFromDb, setPrizepacksFromDb] = useState(null);
  const [prizepacksRetrieved, setPrizepacksRetrieved] = useState(false);
  const prizePacksRef = useRef();
  const prizepacksListenerRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/manager/');

  useEffect(() => {
    if (!gameData?.gameName) return;
    changeDocumentTitle(`Prize Packs | Manage ${gameData?.gameName || ''}`);
  }, [gameData?.gameName])

  useEffect(() => {
    if (!gameId) return;
    getGameElementsToManage();
    function getGameElementsToManage() {
      if (isPreview) {
        if (!completeGameElementData) return;
        const prizePackObj = {};
        Object.values(completeGameElementData)
          .filter(e => e.type === 'item' && e.opt_itemType === 'prizepack' && e.status === 'active')
          .forEach(e => {
            prizePackObj[e.id] = e;
          });
        prizePacksRef.current = prizePackObj;
        setPrizepacksFromDb(prizePacksRef.current);
        return;
      }
      getCollectionFromDb({
        "collection": `games/${gameId}/gameElements`,
        "query1": {
          "key": "type",
          "condition": "==",
          "value": "item"
        },
        "query2": {
          "key": "opt_itemType",
          "condition": "==",
          "value": "prizepack"
        },
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        prizePacksRef.current = {
          ...prizePacksRef.current,
          ...{ [data.id]: data }
        }
        setPrizepacksFromDb(prizePacksRef.current);
      }
      function handleListener(data) {
        prizepacksListenerRef.current = data;
      }
    }

    return () => {
      if (prizepacksListenerRef.current) {
        prizepacksListenerRef.current();
        prizepacksListenerRef.current = null;
      }
    }
  }, [gameId, isPreview, completeGameElementData])

  function checkMembershipForNewItem(e) {
    const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'create': true });
    if (res.disabled && res.disabledReason.includes('elements')) {
      const planRest = membershipRestrictions[membership.membership];
      const message = `While using the ${planRest.title}, you are only able to have ${planRest.elementCount} active Game Elements per game.`;
      setShowUpgradeModal(message);
      return;
    }
    navigate('create');
  }



  return (
    <div className='prize-packs-landing'>
      <Routes>
        <Route path='' element={
          <div className='g-card prize-packs-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer
                src='/images/icons/prizepacks.png'
                alt='prize packs icon'
                className='head-icon'
              />
              Create and Edit Prize Packs
              {/* <div className='buttons'>
                                <button 
                                    type='button' 
                                    className='g-button med-btn' 
                                    onClick={() => checkMembershipForNewItem()}
                                >
                                    Create a New Pack
                                    <FontAwesomeIcon icon={faPlus} />
                                </button>
                            </div> */}
            </div>
            <hr />
            <div className='prize-packs-landing-content'>
              <PrizePacksList
                gameData={gameData}
                gameElements={gameElements}
                prizepacksFromDb={prizepacksFromDb}
                role={role} />
            </div>
          </div>
        }></Route>
        <Route path='create' element={
          <PrizePacksForm
            gameData={gameData}
            gameStats={gameStats}
            gameElements={gameElements}
            prizepacksFromDb={prizepacksFromDb}
            playerList={playerList}
            role={role} />
        }></Route>
        <Route path='edit/:packPath' element={
          <PrizePacksForm
            gameData={gameData}
            gameStats={gameStats}
            gameElements={gameElements}
            prizepacksFromDb={prizepacksFromDb}
            playerList={playerList}
            role={role} />
        }></Route>
      </Routes>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal} />
    </div>
  )
}

export default PrizePacksLanding